import type { IGroupOrLabel } from "../../interfaces";

export const setSelected = (
  state: any,
  keyForData: string,
  selected: IGroupOrLabel | null,
) => {
  if (keyForData === "labels") state.selectedLabel = selected;
  else state.selectedGroup = selected;
};

export const getSelected = (
  state: any,
  keyForData: string,
): IGroupOrLabel | null =>
  keyForData === "labels" ? state.selectedLabel : state.selectedGroup;
